import { Environment } from '../../shared/environment/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { WebsocketService } from '../websocket/websocket.service';
import { StbWebSocketService } from '../websocket/stb-websocket.service';
import { Order } from '../../model/order';
import { EdsIdMapperService } from '../eds-id-mapper/eds-id-mapper.service';
import { OcapiUrlConstants } from '../../shared/ocapi-url-constants';
import { OmapiIdsUtils } from '../../shared/utils/omapi-ids/omapi-ids-utils';
var OcapiAsynchronousService = /** @class */ (function () {
    function OcapiAsynchronousService(httpClient, websocketService, stbWebSocketService, edsIdMapper) {
        this.httpClient = httpClient;
        this.websocketService = websocketService;
        this.stbWebSocketService = stbWebSocketService;
        this.edsIdMapper = edsIdMapper;
    }
    OcapiAsynchronousService.prototype.activatePack = function (order) {
        var _this = this;
        var activatePackObservable;
        if (order.type === Order.DAYPASS) {
            activatePackObservable = this.activateDayPass(order.packOmapiId);
        }
        else {
            if (order.subPackOmapiId) {
                activatePackObservable = this.activateContentPackWithOption(order.packOmapiId, order.subPackOmapiId);
            }
            else {
                activatePackObservable = this.activateContentPack(order.packOmapiId);
            }
        }
        return activatePackObservable.pipe(mergeMap(function (response) {
            return _this.openWebsocketToStbAndSendProductActivationMessage(response, order);
        }));
    };
    OcapiAsynchronousService.prototype.activateTrial = function (trial) {
        var _this = this;
        var activateTrialPackUrl = this.getOcapiAdaptorActionUrl() + '/?t=activatetrial';
        var body = {
            dtvidentifier: OmapiIdsUtils.dtvIdentifier,
            vouchernumber: trial.voucherid,
            salesofferingspecificationid: trial.salesOfferingSpecificationId,
            salesentity: { salesentityid: '68625', salesperson: 'EOS TV Shop' }
        };
        return this.httpClient.post(activateTrialPackUrl, body, this.createHeaderOptions(OmapiIdsUtils.accessToken))
            .pipe(mergeMap(function (response) { return _this.websocketService.listen(response.id); }), map(function (response) {
            var parsedBody = JSON.parse(response.body);
            return _this.mappedResponse(parsedBody);
        }));
    };
    OcapiAsynchronousService.prototype.activateContentPack = function (activatedProductOmapiId) {
        return this.activateContentPackWithOption(activatedProductOmapiId, null);
    };
    OcapiAsynchronousService.prototype.activateContentPackWithOption = function (activatedProductOmapiId, activatedOptionOmapiId) {
        var _this = this;
        var activateContentPackUrl = this.getOcapiAdaptorActionUrl() + '/?t=activatecontentpack';
        var body = {
            dtvidentifier: OmapiIdsUtils.dtvIdentifier,
            activatedproductomapiid: activatedProductOmapiId,
            activatedsubproductomapiid: activatedOptionOmapiId
        };
        return this.httpClient.post(activateContentPackUrl, body, this.createHeaderOptions(OmapiIdsUtils.accessToken))
            .pipe(mergeMap(function (response) { return _this.websocketService.listen(response.id); }), map(function (response) {
            var parsedBody = JSON.parse(response.body);
            return _this.mappedResponse(parsedBody);
        }));
    };
    OcapiAsynchronousService.prototype.activateDayPass = function (activateDayPassOmapiId) {
        var _this = this;
        var activateDayPassUrl = this.getOcapiAdaptorActionUrl() + '/?t=activatedaypass';
        return this.httpClient.post(activateDayPassUrl, this.createActivateDaypassBody(activateDayPassOmapiId), this.createHeaderOptions(OmapiIdsUtils.accessToken))
            .pipe(mergeMap(function (response) { return _this.websocketService.listen(response.id); }), map(function (response) {
            var parsedBody = JSON.parse(response.body);
            return _this.mappedResponse(parsedBody);
        }));
    };
    OcapiAsynchronousService.prototype.openWebsocketToStbAndSendProductActivationMessage = function (response, order) {
        var _this = this;
        if (response.success) {
            return this.edsIdMapper.getByOmapiId(order.packOmapiId)
                .pipe(mergeMap(function (omapiEds) {
                if (omapiEds) {
                    return _this.stbWebSocketService.openWebsocketToSTB().pipe(map(function () { return _this.stbWebSocketService.sendProductActivationMessage(omapiEds.edsIds, omapiEds.description); }), map(function () { return response; }));
                }
                return of(response);
            }));
        }
        return of(response);
    };
    OcapiAsynchronousService.prototype.createHeaderOptions = function (accessToken) {
        return {
            withCredentials: true,
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            })
        };
    };
    OcapiAsynchronousService.prototype.mappedResponse = function (parsedBody) {
        return {
            id: parsedBody.id,
            success: parsedBody.success,
            errorCode: parsedBody.errorcode,
            errorMessage: parsedBody.errormessage
        };
    };
    OcapiAsynchronousService.prototype.createActivateDaypassBody = function (activateDayPassOmapiId) {
        return {
            dtvidentifier: OmapiIdsUtils.dtvIdentifier,
            omapiid: activateDayPassOmapiId,
            salesofferingspecificationid: '141',
            salesentity: { salesentityid: '68625', salesperson: 'EOS TV Shop' }
        };
    };
    OcapiAsynchronousService.prototype.getBaseUrl = function () {
        return Environment.environmentConfig().baseApiUrl;
    };
    OcapiAsynchronousService.prototype.getOcapiAdaptorActionUrl = function () {
        return this.getBaseUrl() + OcapiUrlConstants.OCAPI_ADAPTOR_ACTION;
    };
    return OcapiAsynchronousService;
}());
export { OcapiAsynchronousService };
